import Script from 'next/script';
import { ScriptId } from '@headless-workspace/config';
import MarketingVideoLibraryLoader from './ProductDetailMarketingVideoLibraryLoader';

export const ProductDetailMarketingVideoLibrary = () => {
    return (
        <>
            <Script id={ScriptId.MarketingVideoLibrary} />
            <MarketingVideoLibraryLoader />
        </>
    );
};
